export const domainChecker = (url) => {
  const regex = new RegExp(/(?:http[s]*:\/\/)*(.*?)\.(?=[^/]*\..{2,5})/i);
  return !!url.match(regex);
};
